
export interface IMLOState {
    getAllMLODetails : any;
    getMLOSuccessMessage : any;
    getMLOErrorMessage : any;
    getMLOInternalCode : any;
    inactivateMLCSuccess : any;
    startMLCSuccess : any;
    closeMLCSuccess : any;
    getOlderMlcsSuccess: any;
    getOlderMlcsError: any;
    getMLCDetailsByIdSuccess : any;
    getMLCDetailsByIdError : any;
    getAllClosedMlcsSuccess: any;
    getAllClosedMlcsError: any;
    getClosedMlcByIdSuccess : any;
    getClosedMlcByIdError : any;
    getActivateMLCSuccess : any;
    getActivateMLCError : any;
    getEditClosedMlcsSuccess: any;
    getEditClosedMlcsError: any;
    getMlcByIdWithReleaseDataSuccess : any;
    getMlcByIdWithReleaseDataError : any;
    getFormulaAndMlcSuccess : any;
    getFormulaAndMlcError : any;
    getFormulaByIdForReleaseDataSuccess : any;
    getFormulaByIdForReleaseDataError : any;
    //mail 
    getSendMailwhenCreateMLCSuccess : any;
    getSendMailwhenCreateMLCError : any;
    getSendMailtoWarehouseUsersSuccess :  any;
    getSendMailtoWarehouseUsersError :  any;

    getCloseMlcUserActionSuccess : any;
    getCloseMlcUserActionError : any;
   
}

export const initialMLOState : IMLOState =  {
    getAllMLODetails : null,
    getMLOSuccessMessage : null,
    getMLOErrorMessage : null,
    getMLOInternalCode : null,
    inactivateMLCSuccess : null,
    startMLCSuccess : null,
    closeMLCSuccess : null,
    getOlderMlcsSuccess: null,
    getOlderMlcsError: null,
    getMLCDetailsByIdSuccess : null,
    getMLCDetailsByIdError : null,
    getAllClosedMlcsSuccess: null,
    getAllClosedMlcsError: null,
    getClosedMlcByIdSuccess : null,
    getClosedMlcByIdError : null,
    getActivateMLCSuccess : null,
    getActivateMLCError : null,
    getEditClosedMlcsSuccess: null,
    getEditClosedMlcsError: null,
    getMlcByIdWithReleaseDataSuccess: null,
    getMlcByIdWithReleaseDataError: null,
    getFormulaAndMlcSuccess : null,
    getFormulaAndMlcError : null,
    getFormulaByIdForReleaseDataSuccess : null,
    getFormulaByIdForReleaseDataError : null,
    //mail
    getSendMailwhenCreateMLCSuccess : null,
    getSendMailwhenCreateMLCError : null,
    getSendMailtoWarehouseUsersSuccess : null,
    getSendMailtoWarehouseUsersError : null,
    getCloseMlcUserActionSuccess : null,
    getCloseMlcUserActionError : null
}